module.exports = __webpack_public_path__ + "assets/elections_plain.f87eb2bc.svg";